// import jQuery from 'CommonScripts/jquery-1.10.2'; 

(function (window, document, $) {
    $(document).ready(function () {
        //$.components.registerComponent('#modal-frame-languages', function ($root) {
            // var $root = document.getElementById('modal-frame-languages');
            // $root = $($root); 
        var modalLanguages = {
            dom: {
                base: $('.modal__lang micromodal-slide'),
                baseId: $('#modal-1'),
                saveBtn: $('#languages__button'),
                dataLanguages: $('.languages__container .languages__item'),
                modalId: 'modal-1',
                cookieName: 'lpp_s',
                radioBtns: $('input[name=languages]'),
                modalContent: $('.modal__content'),
                listOfLang: $('.languages-selector .languagelink')
            },
            set: {
                modalSettings: {
                    awaitCloseAnimation: true,
                    awaitOpenAnimation: true
                },
                expireDate: function () {
                    var date = new Date();
                    var daysToExpire = 365;
                    date.setTime(date.getTime() + (daysToExpire * 24 * 60 * 60 * 1000));
                    return date.toGMTString();
                }

            },
            fn: {
                init: function () {
                    // Check if the language spot is present
                    if ($dom.baseId.length) {
                        // Check if a cookie is stored in the client browser
                        if ($fn.getCookie($dom.cookieName)) {
                            return;
                        } else {
                            // load modal settings
                            MicroModal.init($set.modalSettings);
                            $fn.buildLanguagesList($dom.listOfLang);
                            $fn.showModal();
                            $('label.language__item').on('change', function () {
                                        $fn.toggleDisabled();
                                    });
                        }
                    }
                },

                showModal: function () {
                    MicroModal.show($dom.modalId);
                },

                closeModal: function () {
                    MicroModal.close($dom.modalId);
                },

                saveChanges: function () {
                    var languageCode = $('input[name=languages]:checked').attr('id');
                    var chosenLangUrl = $('input[name=languages]:checked').val();
                    $fn.setCookie(true);
                    $fn.setCurrentLanguage(languageCode, chosenLangUrl);
                    $fn.closeModal();
                },

                setCookie: function (language) {
                    document.cookie = '' + $dom.cookieName + '=' + language +
                        '; path=/; expires=' + $set.expireDate() + '"';
                },

                getCookie: function (name) {
                    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
                    return v ? v[2] : null;
                },

                setCurrentLanguage: function (languageCode, languageUrl) {
                    $.ajax({
                        url: "/api/sitecore/api/SetCurrentLanguage?lc=" + languageCode,
                        success: function success(result) {
                            $fn.redirectToUrl(languageUrl);
                        }
                    });
                },

                redirectToUrl: function (languageUrl) {
                    window.location.replace(languageUrl);
                },

                toggleDisabled: function () {
                    $dom.saveBtn.prop('disabled', false);
                },

                buildLanguagesList: function (data) {

                    $.each(data, function (i) {
                        var langCode = data[i].dataset.lang,
                            langHref = $(data[i]).attr('href'),
                            langName = $(data[i]).html();
                        $(
                            '<label class="language__item" for="' + langName + '">' + langName + '' +
                            '<input id="' + langCode + '" type="radio" name="languages" value="' + langHref + '">' +
                            '<span class="checkmark"></span>' +
                            '</label><br>').appendTo($dom.modalContent);
                       
                    });
                }
            }
        },

            $dom = modalLanguages.dom,
            $set = modalLanguages.set,
            $fn = modalLanguages.fn;
        $fn.init();

        $dom.saveBtn.on('click', function () {
            $fn.saveChanges();
        });
    });
})(window, document, jQuery);
/*

(function (window, document, $) {

    $(document).ready(function () {
        //$.components.registerComponent('#modal-frame-languages', function ($root) {
        var modalLanguages = {
            dom: {
                base: $('.modal__lang micromodal-slide'),
                baseId: $('#modal-1'),
                saveBtn: $('#languages__button'),
                dataLanguages: $('.languages__container .languages__item'),
                modalId: 'modal-1',
                cookieName: 'velux_active_preferred_lang',
                radioBtns: $('input[name=languages]'),
                modalContent: $('.modal__content')

            },
            set: {
                modalSettings: {
                    awaitCloseAnimation: true,
                    awaitOpenAnimation: true
                },
                expireDate: function () {
                    var date = new Date();
                    var daysToExpire = 365;
                    date.setTime(date.getTime() + (daysToExpire * 24 * 60 * 60 * 1000));
                    return date.toGMTString();
                },
                languageCode: window.location.href
            },
            fn: {
                init: function () {
                    // Check if the language spot is present
                    if ($dom.baseId.length) {
                        // Check if a cookie is stored in the client browser
                        if ($fn.getCookie($dom.cookieName)) {
                            return;
                        } else {
                            // load modal settings
                            MicroModal.init($set.modalSettings);
                            $.ajax({
                                dataType: "json",
                                url: "/api/sitecore/api/GetLanguages",
                                success: function success(result) {
                                    var languages = result.Languages;
                                    if (languages.length <= 1) // If only one language don't do anything
                                        return;
                                    $dom.modalTitle.html(result.SelectLanguageText);
                                    $dom.saveBtn.html(result.SaveChangesText);
                                    $fn.buildLanguagesList(languages);
                                    $fn.showModal();
                                    $('label.language__item').on('change', function () {
                                        $fn.toggleDisabled();
                                    });
                                }
                            });
                        }
                    }
                },

                showModal: function () {
                    MicroModal.show($dom.modalId);
                },

                closeModal: function () {
                    MicroModal.close($dom.modalId);
                },

                saveChanges: function () {
                    var languageCode = $('input[name=languages]:checked').val();

                    $fn.setCookie('1');
                    $fn.setCurrentLanguage(languageCode);
                    $fn.closeModal();
                },

                setCookie: function (language) {
                    document.cookie = '' + $dom.cookieName + '=' + language +
                        '; path=/; expires=' + $set.expireDate() + '"';
                },

                getCookie: function (name) {
                    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
                    return v ? v[2] : null;
                },

                setCurrentLanguage: function (languageCode) {
                    $.ajax({
                        url: "/api/sitecore/api/SetCurrentLanguage?lc=" + languageCode,
                        success: function success(result) {
                            $fn.redirectToUrl();
                        }
                    });
                },

                redirectToUrl: function (languageCode) {
                    //var langCodeInUrl =
                    window.location.replace(window.location.href + languageCode);
                },

                toggleDisabled: function () {
                    $dom.saveBtn.prop('disabled', false);
                },

                buildLanguagesList: function (data) {
                    $.each(data, function (i) {
                        $(
                            '<label class="language__item" for="' + data[i].LanguageName.toLowerCase() + '">' + data[i].LanguageName + '' +
                            '<input id="' + data[i].LanguageName.toLowerCase() + '" type="radio" name="languages" value="' + data[i].LanguageCode + '">' +
                            '<span class="checkmark"></span>' +
                            '</label><br>').appendTo($dom.modalContent);
                    });
                }
            }
        },

            $dom = modalLanguages.dom,
            $set = modalLanguages.set,
            $fn = modalLanguages.fn;
            $fn.init();

        $dom.saveBtn.on('click', function () {
            $fn.saveChanges();
        });
    });
})(window, document, jQuery);
 */